(async function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    let activeVariant;
    let product = JSON.parse(section.querySelector('.templateProductJSON').textContent)

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    let swiper = new Swiper(section.querySelector('.productV9VisualSwiper'), {
        navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
        }
    })
    section.querySelectorAll(`.productV9VisualThumbsThumbnail`).forEach(function (element) {
        element.addEventListener("click", function () {

            // determine index
            let index = getElIndex(this);

            // change active slide
            swiper.slideTo(index);
        });
    });


    /**************
     Variant Options
     ***************/

        // remember which pack the shopper picked so it survives a plan (sub/once) toggle
    let selectedIndex = 1;

    function isSubscription() {
        return section.querySelector('.productV9FormSubLabelInput:checked')?.value === 'sub';
    }

    // build the option cards for the active plan as one HTML string, then bind their change handlers
    function constructVariantOptions() {
        let products = isSubscription() ? subscriptionProducts : oneTimeProducts;
        let optionsEl = section.querySelector('.productV9FormOptions');

        // clamp the remembered pack index to what this plan offers
        let checkedIndex = selectedIndex;
        if (checkedIndex > products.length - 1) {
            checkedIndex = products.length - 1;
        }

        let html = '';
        products.forEach(function (product, index) {
            let selector = product.variant_selector || {};

            // pre-check the remembered pack
            let checked = '';
            if (index === checkedIndex) {
                checked = 'checked';
            }

            // tag pill (optional) — colored by the metaobject tag_color
            let tagHTML = '';
            if (selector.tag) {
                let tagStyle = '';
                if (selector.tag_color) {
                    tagStyle = ` style="background-color: ${selector.tag_color}"`;
                }
                tagHTML = `<span class="productV9FormOptionsLabelBodyTag"${tagStyle}>${selector.tag}</span>`;
            }

            // shipping frequency (optional, subscription only)
            let frequencyHTML = '';
            if (isSubscription() && selector.frequency_weeks) {
                frequencyHTML = `<span class="productV9FormOptionsLabelBodyInfoFrequency">Ships every ${selector.frequency_weeks} weeks</span>`;
            }

            // supply line (optional)
            let supplyHTML = '';
            if (selector.supply) {
                supplyHTML = `<span class="productV9FormOptionsLabelBodyInfoSupply">${selector.supply}</span>`;
            }

            // strike-through compare price (only when it beats the real price)
            let compareHTML = '';
            if (product.compare_at_price > product.price) {
                compareHTML = `<span class="productV9FormOptionsLabelBodyPriceCompare">${price(product.compare_at_price)}</span>`;
            }

            // per-unit price (optional)
            let unitHTML = '';
            if (selector.unit_price) {
                unitHTML = `<span class="productV9FormOptionsLabelBodyPriceUnit">${selector.unit_price}</span>`;
            }

            // title falls back to the source product's title (minus branding/plan noise) when the metaobject has none
            let title = selector.title;
            if (!title) {
                title = product.product.title
                    .replace(/LIVFRESH/gi, '')
                    .replace(/\(Subscription\)/gi, '')
                    .replace(/\s+/g, ' ')
                    .trim();
            }

            html += `
                <label class="productV9FormOptionsLabel">
                    <input class="productV9FormOptionsLabelInput" type="radio" name="${sectionID}-option" value="${product.id}" ${checked}>
                    <span class="productV9FormOptionsLabelBody">
                        ${tagHTML}
                        <span class="productV9FormOptionsLabelBodyCircle"></span>
                        <span class="productV9FormOptionsLabelBodyInfo">
                            <span class="productV9FormOptionsLabelBodyInfoTitle">${title}</span>
                            ${frequencyHTML}
                            ${supplyHTML}
                        </span>
                        <span class="productV9FormOptionsLabelBodyPrice">
                            <span class="productV9FormOptionsLabelBodyPriceReal">${price(product.price)}</span>
                            ${compareHTML}
                            ${unitHTML}
                        </span>
                    </span>
                </label>
            `;
        });
        optionsEl.innerHTML = html;

        // re-bind: the previous inputs were discarded with the old markup
        optionsEl.querySelectorAll('.productV9FormOptionsLabelInput').forEach(function (input) {
            input.addEventListener('change', updateProduct);
        });
    }

    // rebuild the option cards when the shopper flips between subscribe / one-time
    section.querySelectorAll('.productV9FormSubLabelInput').forEach(function (input) {
        input.addEventListener('change', function () {
            constructVariantOptions();
            updateProduct();
        });
    });

    /**************
     Update Product
     ***************/

    async function updateProduct() {
        let products = isSubscription() ? subscriptionProducts : oneTimeProducts;
        let labels = Array.from(section.querySelectorAll('.productV9FormOptionsLabel'));

        // guard: nothing available to sell
        let checkedInput = section.querySelector('.productV9FormOptionsLabelInput:checked');
        if (!checkedInput) {
            setAvailability(false, 'Unavailable');
            return;
        }

        // remember the pack + resolve the active product
        selectedIndex = labels.findIndex(label => label.querySelector('.productV9FormOptionsLabelInput').checked);
        let selectedId = parseInt(checkedInput.value);
        activeVariant = products.find(product => product.id === selectedId);

        if (Shopify.theme.role === "development") {
            window.activeVariant = activeVariant;
        }

        // swap the gallery + sticky image to the variant's featured image
        if (activeVariant.featured_image) {
            section.querySelector('.productV9VisualSwiperImage').src = activeVariant.featured_image;
            section.querySelector('.productV9StickyBodyLeftImg').src = activeVariant.featured_image;
        }

        // subscription footer line + sticky interval (blank for one-time)
        let selector = activeVariant.variant_selector || {};
        let intervalText = '';
        let footerText = '';
        if (isSubscription() && selector.frequency_weeks) {
            intervalText = `Ships every ${selector.frequency_weeks} weeks`;
            footerText = `This subscription ships every ${selector.frequency_weeks} weeks - Skip, pause, cancel anytime`;
        }
        section.querySelector('.productV9FormFrequency').textContent = footerText;

        // sticky quick-add mirror
        section.querySelector('.productV9StickyBodyRightOptionAmount').textContent = selector.title || '';
        section.querySelector('.productV9StickyBodyLeftMobileAmount').textContent = selector.title || '';
        section.querySelector('.productV9StickyBodyRightOptionInterval').textContent = intervalText;
        section.querySelector('.productV9StickyBodyLeftMobileInterval').textContent = intervalText;
        let stickyCompare = '';
        if (activeVariant.compare_at_price > activeVariant.price) {
            stickyCompare = price(activeVariant.compare_at_price);
        }
        section.querySelector('.productV9StickyBodyRightATCCompare').textContent = stickyCompare;
        section.querySelector('.productV9StickyBodyRightATCPrice').textContent = price(activeVariant.price);

        // inline ATC price (real + strike-through compare)
        section.querySelector('.productV9FormATCPriceReal').textContent = price(activeVariant.price);
        section.querySelector('.productV9FormATCPriceCompare').textContent = stickyCompare;

        // B2B selling-plan select (only rendered for Professional / Distributor) — plans come from this pack's subscription product
        let sellingPlanSelect = section.querySelector('.productV9FormPlanSelect');
        if (sellingPlanSelect) {
            let subProduct = subscriptionProducts[selectedIndex];
            let planHTML = '';
            if (subProduct && subProduct.selling_plans) {
                subProduct.selling_plans.forEach(function (plan) {
                    planHTML += `<option value="${plan.id}">${plan.name}</option>`;
                });
            }
            sellingPlanSelect.innerHTML = planHTML;
        }

        // refresh which welcome gifts are unlocked for this pack + plan
        updateGifts();

        // toggle availability across both add-to-cart buttons
        setAvailability(activeVariant.available, activeVariant.available ? 'Add To Cart' : 'Sold Out');
    }

    // a gift unlocks once the selected pack position reaches its unlock_at threshold; lock-on-one-time gifts need the subscription
    function updateGifts() {
        let track = section.querySelector('.productV9FormGiftsBody');
        if (!track) {
            return;
        }
        let subscribing = isSubscription();

        // selected pack position (1-based) + pack size parsed from the variant SKU (e.g. LIV1153-5S -> 5)
        let position = selectedIndex + 1;
        let packSize = 0;
        if (activeVariant && activeVariant.sku) {
            packSize = parseInt(String(activeVariant.sku).split('-')[1]) || 0;
        }
        let unlockedCount = 0;

        section.querySelectorAll('.productV9FormGiftsBodyItem').forEach(function (gift) {
            let unlockAt = parseInt(gift.dataset.unlockAt) || 1;
            let free = position >= unlockAt;

            // count toward the rail fill before the one-time lock is applied (mirrors the source)
            if (free) {
                unlockedCount++;
            }

            // subscribe-only gifts never unlock on one-time
            if (free && gift.dataset.lockOnOneTime === 'true' && !subscribing) {
                free = false;
            }

            gift.classList.toggle('locked', !free);
            gift.querySelector('.productV9FormGiftsBodyItemImgLock').hidden = free;
            gift.querySelector('.productV9FormGiftsBodyItemSaveFree').textContent = free ? 'FREE' : 'LOCKED';

            // on a 5-pack, a flagged gift (the bonus tube) doubles: multiply savings + duplicate image
            let multi = 1;
            let fiveMulti = parseInt(gift.dataset.fiveMulti) || 1;
            if (packSize === 5 && fiveMulti > 1) {
                multi = fiveMulti;
            }
            renderGiftMultiplier(gift, multi);
        });

        // drive the progress rail fill (teal up to the unlocked count)
        track.style.setProperty('--gifts-unlocked', unlockedCount);
    }

    // scale a gift's savings + duplicate its image when multi > 1; only rebuilds the image when the count changes
    function renderGiftMultiplier(gift, multi) {
        // scale the strike-through savings from the base amount (cents)
        let strike = gift.querySelector('.productV9FormGiftsBodyItemSaveStrike');
        let baseSave = parseInt(gift.dataset.save);
        if (strike && !isNaN(baseSave)) {
            strike.textContent = 'Save ' + price(baseSave * multi);
        }

        // rebuild the image only when the copy count changes, to avoid reload flicker
        let content = gift.querySelector('.productV9FormGiftsBodyItemImgContent');
        if (!content || parseInt(content.dataset.multi) === multi) {
            return;
        }
        content.dataset.multi = multi;

        let url = gift.dataset.image;
        if (multi >= 2) {
            let imgs = '';
            Array.from({length: multi}).forEach(function () {
                imgs += `<img class="productV9FormGiftsBodyItemImgPhoto" src="${url}" alt="">`;
            });
            content.innerHTML = `<span class="productV9FormGiftsBodyItemImgPair">${imgs}</span>`;
        } else {
            content.innerHTML = `<img class="productV9FormGiftsBodyItemImgPhoto" src="${url}" alt="">`;
        }
    }

    // flip both the inline and sticky add-to-cart buttons on/off together
    function setAvailability(available, label) {
        let atc = section.querySelector('.productV9FormATC');
        atc.disabled = !available;
        section.querySelector('.productV9FormATCLabel').textContent = label;

        let stickyAtc = section.querySelector('.productV9StickyBodyRightATC');
        stickyAtc.disabled = !available;
        section.querySelector('.productV9StickyBodyRightATCTxt').textContent = label.toUpperCase();
    }

    // initial paint: build the option cards, then sync price / image / availability
    constructVariantOptions();
    updateProduct();


    /**************
     Product ATC
     ***************/
    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV9FormATC").classList.add("loading");

        let sellingPlan = activeVariant.plan_id || null

        // B2B Selling plan select override
        let sellingPlanSelect = section.querySelector('.productV9FormPlanSelect') || false;
        if (sellingPlanSelect && isSubscription()) {
            sellingPlan = parseInt(sellingPlanSelect.value);
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.variant_id,
                selling_plan: sellingPlan
            }]
        };


        // check for add on
        section.querySelectorAll('.productV3AddOnItemBodySwitchInput:checked')?.forEach(function (element) {
            formData.items.push({
                quantity: 1,
                id: element.dataset.id,
                selling_plan: element.dataset.selling || null
            });
        })

        // check for upsell
        let upsellInput = section.querySelector('.productV9UpsellInput:checked');
        if (upsellInput) {
            formData.items.push({
                quantity: 1,
                id: upsellInput.dataset.id
            });
        }


        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV9FormATC").classList.remove("loading");

        // open cart
        await openCart();

        // record GA4 & Klaviyo tracking
        await tracking(formData);
    }

    section.querySelector('.productV9FormATC').addEventListener("click", addToCart);

    // the ATC button is wrapped in a form for valid markup, but the cart add is handled in JS — block the native submit
    section.querySelector('.productV9FormATCForm').addEventListener("submit", function (e) {
        e.preventDefault();
    });

    // Reviews scroll
    section.querySelectorAll('.productV9DropsItemBodyReviews').forEach(function (element) {
        element.addEventListener("click", function () {
            // scroll to the reviews section, which publishes its own id as reviewsTarget
            const reviews = typeof reviewsTarget === "undefined" ? null : document.querySelector(`#${reviewsTarget}`);
            if (!reviews) {
                return;
            }
            window.scroll({
                top: reviews.offsetTop - 100,
                behavior: "smooth"
            });
        });
    });

    // Show more scroll
    section.querySelectorAll('.productV9DropsItemBtn').forEach(function (element) {
        element.addEventListener("click", function () {
            // scroll to the FAQ filter links, whichever FAQ markup is on the page
            const faqHeaderLinks = document.querySelector(".faqV2HeaderLinks, .faqHeaderLinks");
            if (!faqHeaderLinks) {
                return;
            }
            window.scroll({
                top: faqHeaderLinks.offsetTop - 100,
                behavior: "smooth"
            });
        });
    });

    /**************
     STICKY ATC
     ***************/
    section.querySelectorAll('.productV9StickyBodyRightATC').forEach(function (el) {
        el.addEventListener('click', function () {
            // add loading animation
            this.classList.add('loading');

            addToCart();

            // wait 1 second
            setTimeout(function () {
                // remove loading animation
                el.classList.remove('loading');
            }, 1000);
        });
    });

    // the sticky ATC button is wrapped in a form for valid markup, but the cart add is handled in JS ‚Äî block the native submit
    section.querySelectorAll('.productV9StickyBodyRightATCWrapper').forEach(function (form) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();
        });
    });

    /************
     Dynamic Sold Out
     ************/
    (function () {
        // Get the current date and time
        let currentDate = new Date();
        // let currentDate = new Date("2024-05-29T23:59:00");

        // The date everything is relative to - which is a Sunday.
        let targetDate = new Date("2024-04-28T23:59:00");

        // Increment the counter for every day that has passed
        let daysPassed = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24) % 7);

        // get the next monday from current date
        let nextMonday = new Date(currentDate);
        nextMonday.setDate(currentDate.getDate() + 8 - currentDate.getDay());

        // get the last monday from current date
        let lastMonday = new Date(currentDate);
        lastMonday.setDate(currentDate.getDate() + 1 - currentDate.getDay());

        // Update the text with the incremented number
        section.querySelectorAll(".percentSold")?.forEach(function (element) {
            element.textContent = daysPassed + 91;
        });

        // Update the date with the next monday
        section.querySelectorAll(".preOrderDate")?.forEach(function (element) {
            element.textContent = nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });

        // Update the date with the last Monday
        section.querySelectorAll(".lastOrderDate")?.forEach(function (element) {
            element.textContent = lastMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
        });
    })();


    // dropdown event listeners for each of the titles
    section.querySelectorAll(`.productV9DropsItemTitle`).forEach(function (element) {
        element.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });

    // random number gen (23-100) for checking out now text
    section.querySelectorAll(".productV9CheckingOutNum").forEach(function (element) {
        element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
    });
    // Do it every 3 seconds
    setInterval(function () {
        section.querySelectorAll(".productV9CheckingOutNum").forEach(function (element) {
            element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
        });
    }, 3000);


    /**************
     Product Add On
     ***************/
        // swiper
    let hasAddOns = section.querySelector('.productV3AddOn') || false;
    if (hasAddOns) {
        let addOnSwiper = new Swiper(section.querySelector('.productV3AddOn'), {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
                el: section.querySelector('.productV3AddOnPag'),
                clickable: true,
            },
            breakpoints: {},
        });
    }


    /************
     GA4 & Klaviyo Tracking
     ************/
    async function tracking(formData) {

        // GA4 add_to_cart
        const sourceProduct = activeVariant.product;
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: Shopify.currency.active,
                value: sourceProduct.variants[0].price * quantity / 100,
                items: [{
                    item_id: sourceProduct.id,
                    item_name: sourceProduct.title,
                    item_category: sourceProduct.type,
                    item_variant: sourceProduct.variants[0].title,
                    price: sourceProduct.variants[0].price / 100,
                    quantity: quantity,
                    subscription_item: !!formData.selling_plan,
                }],
                subscription_included: !!formData.selling_plan,
            }
        });

        // push to klavviyo
        try {
            _learnq.push(["track", "Added to Cart", {
                "$value": sourceProduct.price * quantity / 100,
                "AddedItemProductName": sourceProduct.title,
                "AddedItemProductID": sourceProduct.id,
                "AddedItemSKU": sourceProduct.variants[0].sku,
                "AddedItemCategories": sourceProduct.tags,
                "AddedItemImageURL": sourceProduct.featured_image?.src,
                "AddedItemURL": `https://getlivfresh.com/products/${product.handle}`,
                "AddedItemPrice": sourceProduct.price,
                "AddedItemQuantity": 1,
                "ItemNames": [sourceProduct.title],
                "CheckoutURL": "https://livfresh.com/checkout",
                "Items": [{
                    "ProductID": sourceProduct.id,
                    "SKU": sourceProduct.variants[0].sku,
                    "ProductName": sourceProduct.title,
                    "Quantity": quantity,
                    "ItemPrice": sourceProduct.price / 100,
                    "RowTotal": sourceProduct.price * quantity / 100,
                    "ProductURL": `https://getlivfresh.com/products/${product.handle}`,
                    "ImageURL": sourceProduct.featured_image?.src,
                    "ProductCategories": sourceProduct.tags
                }]
            }]);
        } catch (e) {
            console.log(e)
        }
    }


}());